module.exports = __webpack_public_path__ + "img/logo.d04e2c54.png";